import React from 'react';

/**
 * Shared loading indicator.
 * 
 * Usage:
 *   <Loader />              — inline dot
 *   <Loader fullscreen />   — centered in viewport
 *   <Loader centered />     — centered in parent (h-64)
 */
const Loader = ({ fullscreen, centered }) => {
  const dot = <div className="w-1.5 h-1.5 bg-accent rounded-full animate-pulse-slow" />;

  if (fullscreen) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-cream">
        {dot}
      </div>
    );
  }

  if (centered) {
    return (
      <div className="flex justify-center items-center h-64">
        {dot}
      </div>
    );
  }

  return dot;
};

export default Loader;
